export default "__VITE_ASSET__utYdw2_7__"